/**
 * Triggers a browser download for a Blob
 *
 * @param blob - The Blob data to download
 * @param filename - The filename for the downloaded file
 */
export function downloadBlob(blob: Blob, filename: string): void {
	const url = URL.createObjectURL(blob);
	const a = document.createElement("a");
	a.href = url;
	a.download = filename;
	document.body.appendChild(a);
	a.click();
	document.body.removeChild(a);
	URL.revokeObjectURL(url);
}

/**
 * Generates a timestamped filename for exports
 *
 * @param prefix - The filename prefix (e.g., "users", "orders")
 * @param extension - The file extension (default: "csv")
 * @returns Formatted filename like "users_2024-01-15_14-30-45.csv"
 */
export function generateExportFilename(
	prefix: string,
	extension = "csv",
): string {
	const now = new Date();
	const date = now.toISOString().split("T")[0];
	const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
	return `${prefix}_${date}_${time}.${extension}`;
}
